







































































































































































import mixins from 'vue-typed-mixins';
import { DashboardTile, TileLikertScoreOptions } from '@/utils/DashboardUtils';
import { LanguageObject } from '@/i18n';
import cloneDeep from 'lodash.clonedeep';
import { hexToRgb } from '@/utils/ChartUtils';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => TileLikertScoreOptions,
    },
  },

  computed: {
    denominators() {
      return [
        {
          text: this.$tc(
            'model.dashboard.tile.likert_score.denominator.answercount'
          ),
          value: 'answercount',
        },
        {
          text: this.$tc(
            'model.dashboard.tile.likert_score.denominator.netcount'
          ),
          value: 'netcount',
        },
      ];
    },
  },

  beforeMount() {
    this.$emit('input', {
      scorelabel: this.value?.scorelabel || this.$languageobj(),
      denominator: this.value?.denominator || 'answercount',
      questionkeys:
        this.value?.questionkeys?.map((questionkey) => ({
          key: questionkey.key,
          label: questionkey.label || this.$languageobj(),
        })) || [],
      scorekeys:
        this.value?.scorekeys?.map((scorekey) => ({
          score: scorekey.score,
          label: scorekey.label || this.$languageobj(),
        })) || [],
      gradients: {
        start: this.value?.gradients?.start || hexToRgb('#dddddd'),
        middle:
          this.value?.gradients?.middle ||
          hexToRgb(this.$vuetify.theme.themes.light.warning as string),
        end:
          this.value?.gradients?.end ||
          hexToRgb(this.$vuetify.theme.themes.light.success as string),
      },
    });
  },

  methods: {
    addQuestionKey() {
      this.value.questionkeys?.push({
        key: '',
        label: this.$languageobj(),
      });
    },

    removeQuestionKey(index: number) {
      this.value.questionkeys?.splice(index, 1);
    },

    addScoreKey() {
      this.value.scorekeys?.push({
        score: undefined,
        label: this.$languageobj(),
      } as any);
    },

    removeScoreKey(index: number) {
      this.value.scorekeys?.splice(index, 1);
    },
  },
});
